import styled from 'styled-components';
import React from 'react';

export default styled(({ color, ...rest }) => <div {...rest} />)`
  height: 1px;
  background: ${(p) => p.theme[p.color] || 'rgba(0, 0, 0, 0.05)'};
`;
